module.exports = __webpack_public_path__ + "static/media/banner.e930d595.jpeg";